import { Component, ContentChild } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'proto-show-hide-password',
  standalone: false,
  styleUrls: ['./show-hide-password.component.scss'],
  templateUrl: './show-hide-password.component.html',
})
export class ShowHidePasswordComponent {
  @ContentChild(IonInput) input: IonInput;

  public isVisible: boolean = false;

  public toggle(): void {
    this.isVisible = !this.isVisible;

    this.input.type = this.isVisible
      ? 'text'
      : 'password';
  }
}
